<app-content-loading *ngIf="isLoading"></app-content-loading>

<div class="card" *ngIf="filteredCandidates?.length && !isLoading">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h5 class="card-title">{{ texts.candidates | localize }}</h5>
      </div>
      <div class="col-auto">

        <div class="d-inline-block ms-2" ngbDropdown>
          <button ngbDropdownToggle class="btn btn-sm btn-secondary">
            <span *ngIf="!selectedBatch">{{ texts.batchesAll | localize }} <i
                class="fa-solid fa-chevron-down ms-2"></i></span>
            <span *ngIf="selectedBatch">{{ texts.batch | localize }} {{selectedBatch.Index + 1}} <i
                class="fa-solid fa-chevron-down ms-2"></i></span>
          </button>
          <div ngbDropdownMenu>

            <div class="clickable" (click)="selectedBatch = null; applyFilter();" ngbDropdownItem>
              {{ texts.all | localize }}
            </div>
            <div class="clickable" *ngFor="let b of batches" (click)="selectedBatch = b; applyFilter();"
              ngbDropdownItem>
              {{ texts.batch | localize }} {{ b.Index + 1 }}
            </div>
          </div>
        </div>

        <div class="d-inline-block ms-2" ngbDropdown>
          <button ngbDropdownToggle class="btn btn-sm btn-secondary">
            <span *ngIf="selectedStatus=='all'">{{ texts.statusAll | localize }} <i
                class="fa-solid fa-chevron-down ms-2"></i></span>
            <span *ngIf="selectedStatus=='undecided'">{{ texts.undecided | localize }} <i
                class="fa-solid fa-chevron-down ms-2"></i></span>
            <span *ngIf="selectedStatus=='accepted'">{{ texts.accepted | localize }} <i
                class="fa-solid fa-chevron-down ms-2"></i></span>
            <span *ngIf="selectedStatus=='rejected'">{{ texts.rejected | localize }} <i
                class="fa-solid fa-chevron-down ms-2"></i></span>
          </button>

          <div ngbDropdownMenu>
            <div class="clickable" (click)="selectedStatus='all'; applyFilter();" ngbDropdownItem>
              {{ texts.statusAll | localize }}
            </div>
            <div class="clickable" (click)="selectedStatus='undecided'; applyFilter();" ngbDropdownItem>
              {{ texts.undecided | localize }}
            </div>
            <div class="clickable" (click)="selectedStatus='accepted'; applyFilter();" ngbDropdownItem>
              {{ texts.accepted | localize }}
            </div>
            <div class="clickable" (click)="selectedStatus='rejected'; applyFilter();" ngbDropdownItem>
              {{ texts.rejected | localize }}
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
  <div class="card-body card-body-list">

    <div class="row" [scAnchorTarget]="'Bewerber:innen'" *ngIf="project && project.Type == 'Longlist'">

      <div class="col-12 section-title">

        <p *ngIf="!filteredCandidates?.length">
          {{ texts.noCandidates | localize }}
        </p>
      </div>

      <div class="col-12">

        <div class="list-group">
          <a class="list-group-item list-group-item-action" routerLink="/projects/{{project.Id}}/candidates/{{ a.Id }}"
            *ngFor="let a of filteredCandidates; let i = index;">

            <div class="row align-items-center">

              <div class="col-auto">
                <span class="text-muted fw-normal" style="width: 3.5rem;">{{ i+1 }}.</span>
              </div>

              <div class="col-auto">
                <sc-avatar class="circle-danger" [user]="a" size="sm"></sc-avatar>
              </div>

              <div class="col col-shrink ms-n2 candidate-desc">
                <div class="d-inline-block fw-bold candidate-name mb-0">{{ a.FirstName }} {{ a.LastName }}</div>
                <p class="small mb-0 fw-normal text-muted oneline" *ngIf="a.JobTitle">{{ a.JobTitle }}</p>
              </div>

              <!-- <div class="col-auto">
            <span class="badge badge-pill badge-success-soft" *ngIf="a.Assignment.AcceptanceStatus == 'Accepted'">
              <i class="fa-sharp fa-solid fa-check me-2"></i> Ausgewählt
            </span>
            <span class="badge badge-pill badge-light" *ngIf="a.Assignment.AcceptanceStatus == 'Rejected'">
              <i class="fa-sharp fa-solid fa-xmark me-2"></i> Abgelehnt
            </span>
          </div> -->
              <div class="col-auto">
                <app-inline-candidate-status-dropdown [stopClickPropagation] [candidate]="a"
                  [language]="loc.language"></app-inline-candidate-status-dropdown>
              </div>
              <div class="col-auto">
                <a *ngIf="a.XingUri" [stopClickPropagation] class="btn btn-sm btn-dark btn-circle me-2"
                  href="{{a.XingUri}}" target="_blank">
                  <fa class="fa-brands fa-xing"></fa>
                </a>
                <a *ngIf="!a.XingUri" [stopClickPropagation] [preventDefault]
                  class="btn btn-sm btn-dark btn-circle me-2" style="opacity: .5;">
                  <fa class="fa-brands fa-xing"></fa>
                </a>
                <a *ngIf="a.LinkedInUri" [stopClickPropagation] class="btn btn-sm btn-dark btn-circle me-2"
                  href="{{a.LinkedInUri}}" target="_blank">
                  <fa class="fa-brands fa-linkedin-in"></fa>
                </a>
                <a *ngIf="!a.LinkedInUri" [stopClickPropagation] [preventDefault]
                  class="btn btn-sm btn-dark btn-circle me-2" style="opacity: .5;">
                  <fa class="fa-brands fa-linkedin-in"></fa>
                </a>
              </div>

            </div>
          </a>
        </div>

      </div>
    </div>
  </div>
</div>

@if (!filteredCandidates?.length && !isLoading)
{
<div class="row">
    <div class="col-12">
        <div class="card" >            
            <div class="card-body">
                <div class="row align-items-center">
                    <div class="col">
                        <p class="mb-0 text-muted">
                            <i class="fa-sharp fa-solid fa-circle-info me-2"></i> Das Projekt läuft! Du wirst benachrichtigt, wenn die Liste erstellt wurde.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}